import React from "react";
import { Box, Chip, TextField, Autocomplete } from "@mui/material";
import { makeStyles } from "@mui/styles";
import contractStatus from "../../../../constants/contractStatus";
import formatDate from "../../../../utils/formatDate";
import agent from "../../../../agent/agent";

const SelectContract = ({ statistic, onChange }) => {
  const classes = useStyles();
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    agent.get('/statistics')
      .then((res) => setOptions(res.data?.data || []))
      .catch(() => setOptions([]));
  }, []);

  const handleChange = (_, value) => {
    if (value) onChange(value);
  };

  return (
    <Autocomplete
      value={statistic}
      options={options}
      fullWidth
      size="small"
      className={classes.root}
      clearIcon={null}
      isOptionEqualToValue={(option, value) =>
        option?.available_contracts?.contract_id === value?.available_contracts?.contract_id
      }
      getOptionLabel={(opt) => {
        const num = opt?.available_contracts?.number || "";
        const date = formatDate(opt?.available_contracts?.datetime_contract);
        return `№${num} от ${date}`;
      }}
      renderOption={(props, option) => {
        const isActive = statistic?.available_contracts?.contract_id === option?.available_contracts?.contract_id;
        return (
          <Box
            component="li"
            {...props}
            key={option?.available_contracts?.contract_id}
            className={`${classes.option} ${isActive ? classes.optionActive : ""}`}
          >
            <span className={classes.optionText}>
              №{option?.available_contracts?.number} от {formatDate(option?.available_contracts?.datetime_contract)}
            </span>
            <StatusChip status={option?.available_contracts?.status} />
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: statistic ? (
              <Box className={classes.selectedValue}>
                <span>№{statistic?.available_contracts?.number} от {formatDate(statistic?.available_contracts?.datetime_contract)}</span>
                <StatusChip status={statistic?.available_contracts?.status} />
              </Box>
            ) : null,
          }}
          inputProps={{
            ...params.inputProps,
            style: statistic ? { opacity: 0, width: 0, padding: 0 } : {},
          }}
        />
      )}
      onChange={handleChange}
    />
  );
};

const StatusChip = ({ status }) => {
  const meta = contractStatus[String(status)];
  if (!meta) return null;
  return (
    <Chip
      label={meta.label}
      size="small"
      sx={{
        height: 24,
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: meta.colorBg,
        color: meta.colorTx,
        borderRadius: "100px",
      }}
    />
  );
};


const useStyles = makeStyles(() => ({
  root: {
    minWidth: 340,
    "& .MuiInputBase-root": {
      background: "#FFFFFF",
      borderRadius: "4px !important",
      height: 40,
      fontSize: 14,
    },
  },
  selectedValue: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    position: "absolute",
    left: 12,
    right: 40,
    pointerEvents: "none",
    fontSize: 14,
    color: "#27272A",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  option: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
    padding: "8px 16px !important",
    fontSize: 14,
    color: "#27272A",
    "&:hover": {
      backgroundColor: "#F4F4F5 !important",
    },
    "&.Mui-focused": {
      backgroundColor: "#F4F4F5 !important",
    },
  },
  optionActive: {
    backgroundColor: "#E0E7FF !important",
    borderLeft: "3px solid #4F39F6",
    "&:hover, &.Mui-focused, &.Mui-focusVisible, &[aria-selected='true']": {
      backgroundColor: "#E0E7FF !important",
    },
  },
  optionText: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

export default SelectContract;
